import React, { Component } from 'react'
import { APP_URL, AUTH_CLIENT_ID } from 'constants/ResourcesConstants'
import classnames from 'classnames'
import onClickOutside from 'react-onclickoutside-decorator'
import ACCESS from 'utils/Access'
import { getDisplayableIdentities, redirectToLoginPage } from '@driftt/web-auth'
import OrgSwitcherSection from './OrgSwitcherSection'
import AgentStatusSection from './AgentStatusSection'
import { Avatar, H4, P, Icon, Div, Nav, Span, A } from '@driftt/tide-core-legacy'
import { pathOr } from 'ramda'
import withTracking from 'components/hocs/withTracking'

import './style'
const DRIFT_ORG_ID = 1

const getAppLink = (path) => `${APP_URL}${path}`

const DriftStatus = () => (
  <A href={getAppLink('/settings/widget')}>
    <Div className={classnames('agent-flyout-link-container', 'agent-flyout-status-logo')}>
      <Icon name="widget-online" height="18" />
      <Span className="agent-status-flyout-settings-nav-link" role="button">
        Drift status
      </Span>
    </Div>
  </A>
)

const DriftSettings = () => (
  <A href={getAppLink('/settings2/account')}>
    <Div className="agent-flyout-link-container">
      <Icon name="settings-1" height="18" />
      <Span className="agent-status-flyout-settings-nav-link">
        Settings
      </Span>
    </Div>
  </A>
)

const DriftHelp = () => (
  <A href={getAppLink('/help')}>
    <Div className={classnames("agent-flyout-link-container", "agent-flyout-help-logo")}>
      <Icon name="knowledgebase-book" height="18" />
      <Span className="agent-status-flyout-settings-nav-link">
        Drift Help
      </Span>
    </Div>
  </A>
)

const DriftNotifications = () => (
  <A href={getAppLink('/settings2/notifications')}>
    <Div className={classnames("agent-flyout-link-container", "agent-flyout-notification-logo")}>
      <Icon name="notification" height="18" />
      <Span className="agent-status-flyout-settings-nav-link">
        Notifications
      </Span>
    </Div>
  </A>

)

const DriftAdminPanel = () => (
  <A href={getAppLink('/settings2/deal-admin')}>
    <Div className={classnames("agent-flyout-link-container", "agent-flyout-admin-panel")}>
      <Icon name="drift-logo-round" height="18" />
      <Span className="agent-status-flyout-settings-nav-link">
        Drift Admin Panel
      </Span>
    </Div>
  </A>
)

class DriftAgentFlyout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayableIdentities: getDisplayableIdentities(),
    }
  }

  canAccessDriftHelp = () => {
    return (
      this.props.hasDriftHelpCutover &&
      ACCESS.hasScopes('org_admin')
    )
  }

  canAccessDriftAdminPanel = () => {
    const { user } = this.props
    return user.orgId === DRIFT_ORG_ID
  }

  toggleOrgSwitcher = (event) => {
    const { showOrgSwitcher } = this.state
    event.preventDefault()
    this.setState({ showOrgSwitcher: !showOrgSwitcher })
  }

  logoutUser = () => {
    this.props.track("User logged out")
    redirectToLoginPage(AUTH_CLIENT_ID)
  }

  render() {
    const {
      user,
      trafficControlConfig
    } = this.props
    const { showOrgSwitcher } = this.state
    const hasAgentStatus = pathOr(false, ['hasAgentStatus'], trafficControlConfig)
    const hasNotifications = pathOr(false, ['hasNotifications'], trafficControlConfig)
    const hasDriftStatus = pathOr(false, ['hasDriftStatus'], trafficControlConfig)

    return (
      <Div className="drift-status-flyout">
        <Div className="agent-status-flyout-header">
          <Div className="agent-status-flyout-header-container">
          <Avatar
            withPresence={true}
            availability={user.availability === 'AVAILABLE' ? 'available' : 'away'}
            withBorder={false}
            user={user}
            size="small"
          />
          <H4 className="agent-status-flyout-header-name"> {user.name || user.email} </H4>
          <P className="agent-status-flyout-profile-url"> {user.email} </P>
          </Div>
        </Div>

        <Div className="drift-status-options-wrapper">
          {hasAgentStatus && <AgentStatusSection />}
          <Nav>
            {hasDriftStatus && <DriftStatus />}
            {hasNotifications && <DriftNotifications />}
            <DriftSettings />
            {this.canAccessDriftHelp() && 
              <DriftHelp />
            }
            {this.canAccessDriftAdminPanel() && <DriftAdminPanel />}
          </Nav>
        </Div>
        <Div className="agent-status-section drift-status-options-wrapper drift-status-options-switch-account">
          <A className="agent-status-flyout-settings-nav-action" onClick={this.toggleOrgSwitcher} href="/" role="button">
            Switch account
          </A>
          {showOrgSwitcher && <OrgSwitcherSection onChange={() => this.setState({ displayableIdentities: getDisplayableIdentities() })} /> }
          <Div className="agent-status-flyout-settings-nav-action" onClick={this.logoutUser}>
            Sign out
          </Div>
        </Div>
      </Div>
    )
  }
}

export default withTracking(onClickOutside(DriftAgentFlyout))



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/Popover/index.js